export const CONTACT_INFO = {
	companyName: "MAWEX Mateusz Węgrzyn Łukasz Multan Spółka Jawna",
	companyAdress1: "ul. Ciepła 11",
	companyAdress2: "32-800 Brzesko",
	phone: "+48 793 272 000",
	phone_1: "+48 733 828 400",
	mail: "rozliczenia@mawex-biuro.pl",
	facebook: "https://www.facebook.com/mawex/",
	gmp: "https://www.google.com/maps/place/MAWEX+czas+pracy+kierowc%C3%B3w/@49.9737283,20.629257,17z/data=!3m1!4b1!4m5!3m4!1s0x47162785173fe8f1:0xb773b9f70df6d39e!8m2!3d49.9737335!4d20.6292521",
	nip: "PL 869-199-80-27",
	regon: "385977015",
	krs: "0000839053",
	account: "83 1050 1562 1000 0092 7709 1279",
};
